module.exports = __webpack_public_path__ + "img/greenbutton.838f3bd1.svg";